import { render, staticRenderFns } from "./empty-data.vue?vue&type=template&id=fa429482&scoped=true&"
import script from "./empty-data.vue?vue&type=script&lang=js&"
export * from "./empty-data.vue?vue&type=script&lang=js&"
import style0 from "./empty-data.vue?vue&type=style&index=0&id=fa429482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa429482",
  null
  
)

export default component.exports